export default function fAccordion() {
	const aAccordions = document.querySelectorAll('.js-accordion');

	const fInitAccordion = (oAccordion) => {
		const aTriggers = oAccordion.querySelectorAll('.js-accordion-open');
		const bOpenOne = oAccordion.getAttribute('data-accordion-openOne') ? oAccordion.getAttribute('data-accordion-openOne') : true;

		for (let b = 0; b < aTriggers.length; b += 1) {
			const oParent = aTriggers[b].parentNode;
			const oCollapse = oParent.querySelector('.js-accordion-collapse');
			const oCollapseHeight = oCollapse.querySelector('.accordion__item__collapse__body').offsetHeight;

			oCollapse.style.height = '0px';
			oCollapse.style.position = 'relative';
			oCollapse.style.opacity = 1;
			oCollapse.style.visibility = 'visible';

			aTriggers[b].addEventListener('click', () => {
				if (oParent.getAttribute('data-accordion-active')) {
					oCollapse.style.height = '0px';
					oParent.removeAttribute('data-accordion-active');
				} else {
					if (bOpenOne) {
						let oCurrent = oAccordion.querySelector('[data-accordion-active="true"]');

						if (oCurrent) {
							let oCurrentCollapse = oCurrent.querySelector('.js-accordion-collapse');

							oCurrentCollapse.style.height = '0px';
							oCurrent.removeAttribute('data-accordion-active');
						}
					}

					oCollapse.style.height = `${oCollapseHeight}px`;
					oParent.setAttribute('data-accordion-active', true);
				}
			});
		}
	};

	for (let a = 0; a < aAccordions.length; a += 1) {
		fInitAccordion(aAccordions[a]);
	}
}
